import Layout from "../../../Components/Layout";
import WishlistList from "../../../Components/User/Events/WishlistList";

const WishlistPage = () => {
  return (
    <Layout
      Heading="Wishlist"
      TitleMark="W"
      TitleMarkClassName="event-wishlist-title-mark"
      TitleClassName="event-wishlist-title"
      HeadClassName="event-wishlist-head"
      activeMenuId="wishlist"
      ExtraclassName="event-wishlist-panel"
    >
      <WishlistList />
    </Layout>
  );
};

export default WishlistPage;
